"use client";

import { useState } from "react";
import type { PlainCatalogStrings } from "@/lib/i18n/catalog-strings";
import { FilterPanel } from "./FilterPanel";

export function FilterDrawer({ strings }: { strings: PlainCatalogStrings }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        data-testid="filter-drawer-trigger"
        onClick={() => setOpen(true)}
        className="inline-flex h-9 items-center gap-2 rounded-md border border-zinc-300 bg-white px-3 text-sm font-medium text-zinc-700 hover:bg-zinc-50 lg:hidden"
      >
        {strings.filterButtonLabel}
      </button>
      {open && (
        <div
          data-testid="filter-drawer-overlay"
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
        >
          <div
            data-testid="filter-drawer"
            onClick={(e) => e.stopPropagation()}
            className="absolute left-0 top-0 h-full w-80 max-w-[85vw] overflow-y-auto bg-white p-6 shadow-xl"
          >
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-lg font-semibold">
                {strings.filterButtonLabel}
              </h2>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Close"
                className="h-8 w-8 rounded-md text-xl hover:bg-zinc-100"
              >
                x
              </button>
            </div>
            <FilterPanel strings={strings} />
          </div>
        </div>
      )}
    </>
  );
}
